import { useLanguage } from "../contexts/LanguageContext";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Globe } from "lucide-react";

const LanguageSelector = ({ variant = "default", showLabel = false }) => {
  const { language, setLanguage, supportedLanguages } = useLanguage();
  
  const currentLang = supportedLanguages[language];
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant={variant === "ghost" ? "ghost" : "outline"} 
          size="sm"
          className="gap-2"
          data-testid="language-selector"
        >
          <span className="text-base">{currentLang?.flag}</span>
          {showLabel && (
            <span className="hidden sm:inline text-sm">{currentLang?.name}</span>
          )}
          {!showLabel && <Globe className="w-4 h-4" />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {Object.entries(supportedLanguages).map(([code, { name, flag }]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLanguage(code)}
            className={`gap-2 cursor-pointer ${language === code ? 'bg-accent' : ''}`}
            data-testid={`lang-option-${code}`}
          >
            <span className="text-base">{flag}</span>
            <span>{name}</span>
            {language === code && (
              <span className="ml-auto text-primary">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
